const API = "https://jm.komerzy.com/backend/?url=vehiculoapi";

export const getVehiculos = async () => {
  const res = await fetch(`${API}&action=listar`);
  const json = await res.json();
  return json.data;
};

export const saveVehiculo = async (data) => {
  const res = await fetch(`${API}&action=guardar`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return res.json();
};

export const deleteVehiculo = async (idvehiculo) => {
  const res = await fetch(`${API}&action=eliminar`, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ idvehiculo }),
  });
  return res.json();
};